import { type } from "arktype";

import { FIELDS, type Draft } from "./fields";
import { fieldError } from "./validation";
import { PRETENSAO_OUTRO, type Pretensao, pretensaoOrder } from "@/lib/labels/lead-instagram";

function field(key: keyof Draft) {
	const definition = FIELDS.find((field) => field.key === key);

	if (definition === undefined) {
		throw new Error(key);
	}

	return type("string").narrow((value, ctx) => {
		const error = fieldError(definition, value);

		return error === null || ctx.mustBe(error);
	});
}

const form = type({
	name: field("name"),
	phone: field("phone"),
	pretensao: field("pretensao").narrow((value): value is Pretensao =>
		pretensaoOrder.some((option) => option === value),
	),
	"pretensao_detail?": "string",
	"age?": field("age"),
	"city?": field("city"),
	hp: "string",
}).narrow((values, ctx) => {
	if (values.pretensao !== PRETENSAO_OUTRO || values.pretensao_detail?.trim().length) {
		return true;
	}

	return ctx.mustBe("Esse campo e obrigatorio");
});

export const InstagramFormSchemas = { form };

export type InstagramFormValues = typeof InstagramFormSchemas.form.infer;
export type InstagramFormInput = typeof InstagramFormSchemas.form.inferIn;
